export class TidalConfigModel {

    /**
     * Math multiplier
     */
    math_multiplier: bigint = BigInt(1000000000);

    /**
     * Percentage divider
     */
    percentage_divider: bigint = BigInt(1000);

    /**
     * Admin percentage
     */
    admin_percentage: bigint = BigInt(20);

    /**
     * Cycle percentage
     */
    cycle_percentage: bigint = BigInt(30);

    /**
     * Exchange percentage
     */
    exchange_percentage: bigint = BigInt(950);

    /**
     * Exchange divider
     */
    exchange_divider: bigint = BigInt(1000000);

    /**
     * Win max multiplier
     */
    win_max_multiplier: bigint = BigInt(190);

    /**
     * Win min amount
     */
    win_min_amount: bigint = BigInt(1000000000);

    /**
     * Win max amount
     */
    win_max_amount: bigint = BigInt(1000000000000);

    /**
     * Buy min amount
     */
    buy_min_amount: bigint = BigInt(1000000000);

    /**
     * Buy max amount
     */
    buy_max_amount: bigint = BigInt(1000000000000);

    /**
     * Buy tax base
     */
    buy_tax_base: bigint = BigInt(500);

    /**
     * Buy tax increment
     */
    buy_tax_increment: bigint = BigInt(100);

    /**
     * Sell tax ratio
     */
    sell_tax_ratio: bigint = BigInt(990);

    /**
     * Expiry timer
     */
    expiry_timer: bigint = BigInt(28800000);

    /**
     * Expiry tax ratio
     */
    expiry_tax_ratio: bigint = BigInt(950);

    /**
     * Expiry divider
     */
    expiry_divider: bigint = BigInt(1000000);

    /**
     * Exchange rate default
     */
    exchange_rate_default: bigint = BigInt(10000);

    /**
     * Exchange rate max
     */
    exchange_rate_max: bigint = BigInt(20000);

    /**
     * Random max
     */
    random_max: bigint = BigInt(99);

    /**
     * Holders node limit
     */
    holders_node_limit: bigint = BigInt(1000);

    /**
     * Rates node limit
     */
    rates_node_limit: bigint = BigInt(20);
}